import { ComplaintDTO } from '../../../../Domain/DTO/ComplaintDTO';
import { EComplaintState } from '../../../../Domain/Enum/EComplaintState';
import { CloseAction } from '../Action/CloseAction';
import { MarkAsSatisfiedAction } from '../Action/MarkAsSatisfiedAction';
import { MarkAsSolutionAgreedAction } from '../Action/MarkAsSolutionAgreedAction';
import { ProposeSolutionAction } from '../Action/ProposeSolutionAction';
import { ComplaintStatusDefault } from './ComplaintStatusDefault';
import { Processed } from './Processed';
import { CancelAction } from '../Action/CancelAction';

export class HarmonizationOfConditions extends ComplaintStatusDefault{

    public TitleCurrent : string = "complaint:StatusHarmonizationOfConditionsCurrent";
    public TitleFinished: string = "complaint:StatusHarmonizationOfConditionsFinished";
    public TitleFuture  : string = "complaint:StatusHarmonizationOfConditionsFuture";

    public GetActions(dto: ComplaintDTO){
        return [new MarkAsSolutionAgreedAction(), new ProposeSolutionAction(), new CancelAction()];
    }

    constructor(){
        super();
        this._prevState = new Processed();
        this._currentStatus = EComplaintState.HarmonizationOfConditions;
    }
}